








































import { Vue, Component } from 'vue-property-decorator'

export default Vue.extend({
    name: "Authenticate",
    data() {
        return {
            user: {
                firstName: "",
                lastName: "",
                birthDate: ""
            },
            methods: [],
            methodError: "",
            termsChecked: false
        }
    },
    created(): void {
        localStorage.resource = this.$route.params.eventUrl;
        this.$store.dispatch("API_CALL", { method: "get", url: "/auth/ftn/methods" }).then((res) => {
            this.methods = res.data;
        }).catch((err) => {
            this.cueError(err.response.data.message)
        })
    },
    methods: {
        chooseMethod(acr: string): void {
            if(!acr) return
            this.$store.dispatch("API_CALL", { method: "get", url: "/auth/ftn", params: {
                acr
            }}).then((res) => {
                window.location.href = res.data.url;
            }).catch((err) => {
                this.cueError(err.response.data.message);
            })
        },
        loginWithCredentials() {
            this.$store.dispatch("API_CALL", { method: "post", url: "/auth/userlogin", data: {
                user: this.user,
                eventURL: this.$route.params.eventUrl,
            }}).then((res) => {
                localStorage.access_token = "Mounted";
                localStorage.userId = res.data.user._id;
                this.$store.commit("setUserInfo", res.data);
                this.$router.push("/" + res.data.event.url);
            }).catch((err) => {
                this.cueError(err.response.data.message);
            })
        },
        cueError(error: string): void {
            this.methodError = error;
            setTimeout(() => {
                this.methodError = "";
            }, 3000);
        }
    },
    computed: {
        event() {
            return this.$store.state.event;
        }
    }
})
